import { render, staticRenderFns } from "./vPaginate1.vue?vue&type=template&id=705ee333"
import script from "./vPaginate1.vue?vue&type=script&lang=js"
export * from "./vPaginate1.vue?vue&type=script&lang=js"
import style0 from "./vPaginate1.vue?vue&type=style&index=0&id=705ee333&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports